module.exports = __webpack_public_path__ + "73b4b244a486f7bdaabf4c1efb6a8605.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/img/logo_copy.png
// module id = 74
// module chunks = 0